import React from 'react';
import { Source, Layer } from 'react-map-gl';

const ForecastRegionLayer = (props) => {
  const { geoJson, severity } = props;

  const fillColor = {
    warning: '#E53E3E',
    advisory: '#ED8936',
    watch: '#ED8936',
  };

  // Generates a unique layer ids
  const generateLayerId = (baseId, index) => `${baseId}-${index}`;

  // Generates a unique source ids
  const generateSourceId = (baseId, index) => `${baseId}-source-${index}`;

  return (
    <>
      {geoJson.map((geoJson, index) => {
        const fillLayer = {
          id: generateLayerId(severity ? `${severity}-region-fill-layer` : 'region-fill-layer', index),
          type: 'fill',
          source: generateSourceId(severity ? `${severity}-forecast-region` : 'region-region', index),
          paint: {
            'fill-color': severity ? fillColor[severity] : '#ecf5f8',
            'fill-opacity': 0.8
          },
        };

        const outlineLayer = {
          id: generateLayerId(severity ? `${severity}-region-outline-layer` : 'region-outline-layer', index),
          type: 'line',
          source: generateSourceId(severity ? `${severity}-forecast-region` : 'region-region', index),
          paint: {
            'line-color': severity ? '#fff' : '#4d84a2',
            'line-width': 2 // make relative to zoom level?
          },
        };

        return (
          <Source key={index} type="geojson" data={geoJson}>
            <Layer {...fillLayer} />
            <Layer {...outlineLayer} />
          </Source>
        );
      })}
    </>
  );
};

export default ForecastRegionLayer;
